import React, { useState, useEffect } from "react";

import "./style.css";

import Typewriter from "../../utils/Typewriter";

import logo from "../../assets/logo.png";
import brasil from "../../assets/brasil.jpg";
import parana from "../../assets/parana.png";
import maringa from "../../assets/maringa.png";

const Header = () => {
  return (
    <header>
      <div class="logo">
        <img src={logo} alt="Leão Truck Parts" className="logo-img"></img>
      </div>
      <div class="typewriter">
        <Typewriter texts={["LEÃO TRUCK PARTS"]} speed={150} />
      </div>
      <div class="bandeiras">
        <img
          src={brasil}
          alt="Leão Truck Parts Bandeira do Brasil"
          className="brasil-img"
        />
        <img
          src={parana}
          alt="Leão Truck Parts Bandeira do Paraná"
          className="parana-img"
        />
        <img
          src={maringa}
          alt="Leão Truck Parts Bandeira de Maringá"
          className="maringa-img"
        />
      </div>
    </header>
  );
};

export default Header;
